module.exports = __webpack_public_path__ + "static/img/pei16.18e6b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pei16.jpg
// module id = rrum
// module chunks = 18